import React from 'react';
import { Link } from 'react-router-dom';
import IconHome from 'cccisd-icons/home2';

// Shown in place of the 404 on the SmartWrap pages when a CC or Supervisor still
// has a working login but their page access has been removed - either their
// per-page toggles were turned off or they are no longer enrolled in SmartWrap,
// both of which empty the pawn's permissions (PawnEventHooks@checkCCInfo).
const SmartWrapAccessRemoved = () => (
    <div>
        <br />
        <div className="alert alert-warning" role="alert">
            <h4 className="alert-heading">You no longer have access to this page</h4>
            <p>
                Your account is still active, but access to some or all of the SmartWrap pages has been removed. If you
                think this is a mistake, contact your supervisor or site administrator.
            </p>
            <Link className="btn btn-primary" to="/">
                <IconHome spaceRight />
                Take Me Home
            </Link>
        </div>
    </div>
);

export default SmartWrapAccessRemoved;
